import actionTypes from "./constants";

const setNetworkInfo = (networkQuality: number, networkSpeed: number) => ({
  payload: { networkQuality, networkSpeed },
  type: actionTypes.SET_NETWORK_INFO,
});

const setConnected = () => ({
  type: actionTypes.CONNECT,
});

const setDisconnected = () => ({
  type: actionTypes.DISCONNECT,
});

const resetNetwork = () => ({
  type: actionTypes.RESET,
});

export { resetNetwork, setNetworkInfo, setConnected, setDisconnected };
